<template>
  <div>

    <loading :active.sync="isLoading"
             :is-full-page="fullPage"></loading>
    <div class="row">
      <div class="col-md-6">
        <h4>Filters:</h4>
      </div>
      <div class="col-md-6">
        <button style="margin-left: 10px;" type="button" class="btn btn-primary float-right" @click="clearFilter">Clear All</button>
      </div>
    </div>

    <div class="row" style="margin-bottom: 20px;">
      <div class="col-md-6">
        <div>
          By date:
        </div>

        <date-picker :lang="lang" v-model="start_date" valueType="format" :first-day-of-week="1"></date-picker> to
        <date-picker :lang="lang" v-model="end_date" valueType="format" :first-day-of-week="1"></date-picker> &nbsp;&nbsp;
        <button type="button" class="btn btn-danger" @click="getEPurseTransfersData">Filter</button>

      </div>
      <div class="col-md-3">
        <div>
          By Status:
        </div>
        <select class="form-control" v-model="status" @change="getEPurseTransfersData">
          <option value="all"> All </option>
          <option value="PENDING">Pending</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
        </select>
      </div>
    </div>

    <br/>

    <div style="overflow-x: scroll;">
      <b-table striped hover :items="transfers" :fields="columns">

        <template v-slot:cell(sender)="data">
          <a style="text-decoration: underline; font-weight: bolder;" :href="'/apps/customer/'+data.value.id" v-if="data.value">
            {{ data.value.name }}<br/>
            <small>{{ data.value.mobileNumber }}</small>
          </a>
        </template>

        <template v-slot:cell(recipient)="data">
          <a style="text-decoration: underline; font-weight: bolder;" :href="'/apps/customer/'+data.value.id" v-if="data.value">
            {{ data.value.name }}<br/>
            <small>{{ data.value.mobileNumber }}</small>
          </a>
        </template>

        <template v-slot:cell(amount)="data">
          <span>KES. {{ data.value | number('0,0.00') }}</span>
        </template>

        <template v-slot:cell(cashValue)="data">
          <span>KES. {{ data.value | number('0,0.00') }}</span>
        </template>

        <template v-slot:cell(loyaltyPoints)="data">
          <span>{{ data.value | number('0,0') }}</span>
        </template>

        <template v-slot:cell(transferredBy)="data">
          <span v-if="data.value">{{ data.value.name }}</span>
        </template>

        <template v-slot:cell(approvedBy)="data">
          <span v-if="data.value">{{ data.value.name }}</span>
        </template>

        <template v-slot:cell(status)="data">
          <span class="badge badge-warning" v-if="data.value == 'PENDING'">
            Pending
          </span>
          <span class="badge badge-success" v-else-if="data.value == 'APPROVED'">
            Approved
          </span>
          <span class="badge badge-danger" v-else>
            Rejected
          </span>
        </template>

        <template v-slot:cell(created)="data">
          {{ data.value }}
        </template>

        <template v-slot:cell(approvedOn)="data">
          <span v-if="data.value">{{ data.value }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:cell(options)="data">
          <b-dropdown text="options">
            <b-dropdown-item href="#" @click="viewTransferDetails(data.item)">View Details</b-dropdown-item>
            <b-dropdown-item href="#" v-if="data.item.status == 'PENDING'" @click="openApprovalModal(data.item, 'APPROVED')">Approve</b-dropdown-item>
            <b-dropdown-item href="#" v-if="data.item.status == 'PENDING'" @click="openApprovalModal(data.item, 'REJECTED')">Reject</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>

    <div class="row">
      <div class="col-md-12">
        <nav aria-label="Page navigation float-right" style="margin-top: 20px;">
          <ul class="pagination justify-content-center">
            <li v-if="pagination.current_page > 1" class="page-item"><a @click.prevent="changePage(pagination.current_page - 1)" class="page-link" href="#">Previous</a></li>
            <li v-for="page in pagesNumber"
                v-bind:class="[ page == isActived ? 'active' : '']" class="page-item"><a @click.prevent="changePage(page - 1)" class="page-link" href="#">{{ page }}</a></li>
            <li v-if="pagination.current_page < pagination.last_page" class="page-item"><a @click.prevent="changePage(pagination.current_page + 1)" class="page-link" href="#">Next</a></li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- Transfer Details Modal -->
    <b-modal id="transfer-details" :title="'Transfer Details'" size="lg" centered>
      <div v-if="selectedTransfer">
        <b-row>
          <b-col cols="6">
            <h5>Sender Information</h5>
            <p><strong>Name:</strong> {{ selectedTransfer.sender ? selectedTransfer.sender.name : '-' }}</p>
            <p><strong>Phone:</strong> {{ selectedTransfer.sender ? selectedTransfer.sender.mobileNumber : '-' }}</p>
            <p><strong>Loyalty ID:</strong> {{ selectedTransfer.sender ? selectedTransfer.sender.loyaltyId : '-' }}</p>
            <p><strong>Registered On:</strong> {{ selectedTransfer.sender ? selectedTransfer.sender.created : '-' }}</p>
          </b-col>
          <b-col cols="6">
            <h5>Recipient Information</h5>
            <p><strong>Name:</strong> {{ selectedTransfer.recipient ? selectedTransfer.recipient.name : '-' }}</p>
            <p><strong>Phone:</strong> {{ selectedTransfer.recipient ? selectedTransfer.recipient.mobileNumber : '-' }}</p>
            <p><strong>Loyalty ID:</strong> {{ selectedTransfer.recipient ? selectedTransfer.recipient.loyaltyId : '-' }}</p>
            <p><strong>Registered On:</strong> {{ selectedTransfer.recipient ? selectedTransfer.recipient.created : '-' }}</p>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col cols="12">
            <h5>Transfer Details</h5>
            <p><strong>Amount:</strong> KES. {{ selectedTransfer.amount | number('0,0.00') }}</p>
            <p><strong>Cash Value:</strong> KES. {{ selectedTransfer.cashValue | number('0,0.00') }}</p>
            <p><strong>Loyalty Points:</strong> {{ selectedTransfer.loyaltyPoints | number('0,0') }}</p>
            <p><strong>Status:</strong> <span :class="{'badge badge-warning': selectedTransfer.status == 'PENDING', 'badge badge-success': selectedTransfer.status == 'APPROVED', 'badge badge-danger': selectedTransfer.status == 'REJECTED'}">{{ selectedTransfer.status }}</span></p>
            <p><strong>E-purse Balance at Initiation:</strong> KES. {{ selectedTransfer.epurseBalanceAtInitiation | number('0,0.00') }}</p>
            <p v-if="selectedTransfer.approvedOn"><strong>E-purse Balance After Approval:</strong> KES. {{ selectedTransfer.epurseBalanceAfterApproval | number('0,0.00') }}</p>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col cols="12">
            <h5>Additional Information</h5>
            <p><strong>Transferred By:</strong> {{ selectedTransfer.transferredBy ? selectedTransfer.transferredBy.name : '-' }}</p>
            <p><strong>Created:</strong> {{ selectedTransfer.created }}</p>
            <p v-if="selectedTransfer.approvedBy"><strong>Approved By:</strong> {{ selectedTransfer.approvedBy.name }}</p>
            <p v-if="selectedTransfer.approvedOn"><strong>Approved On:</strong> {{ selectedTransfer.approvedOn }}</p>
            <p v-if="selectedTransfer.reason"><strong>Reason:</strong><br/>{{ selectedTransfer.reason }}</p>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('transfer-details')">Close</b-button>
      </template>
    </b-modal>

    <!-- Approval/Rejection Modal -->
    <b-modal id="approval-modal" :title="approvalAction == 'APPROVED' ? 'Approve Transfer' : 'Reject Transfer'" @ok="processApproval" centered>
      <form action="#" class="form-horizontal" method="post">
        <div class="form-body">
          <div class="row">
            <div class="col-md-12">
              <p v-if="selectedTransfer">
                Are you sure you want to <strong>{{ approvalAction == 'APPROVED' ? 'approve' : 'reject' }}</strong> this transfer of
                <strong>{{ selectedTransfer.loyaltyPoints | number('0,0') }} points</strong>
                from <strong>{{ selectedTransfer.sender ? selectedTransfer.sender.name : '' }}</strong>
                to <strong>{{ selectedTransfer.recipient ? selectedTransfer.recipient.name : '' }}</strong>?
              </p>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      pagination: {
        total: 0,
        per_page: 10,
        from: 1,
        to: 0,
        current_page: 0
      },
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      offset: 4,
      columns: [
        {
          key: 'sender',
          label: 'Sender',
          sortable: false
        },
        {
          key: 'recipient',
          label: 'Recipient',
          sortable: false
        },
        {
          key: 'amount',
          label: 'Amount',
          sortable: false
        },
        {
          key: 'cashValue',
          label: 'Cash Value',
          sortable: false
        },
        {
          key: 'loyaltyPoints',
          label: 'Loyalty Points',
          sortable: false
        },
        {
          key: 'status',
          label: 'Status',
          sortable: false
        },
        {
          key: 'transferredBy',
          label: 'Transferred By',
          sortable: false
        },
        {
          key: 'created',
          label: 'Created',
          sortable: false
        },
        {
          key: 'approvedBy',
          label: 'Approved By',
          sortable: false
        },
        {
          key: 'approvedOn',
          label: 'Approved On',
          sortable: false
        },
        {
          key: 'options',
          label: 'Options',
          sortable: false
        }
      ],
      transfers: [],
      start_date: "all",
      end_date: "all",
      status: "all",
      selectedTransfer: null,
      approvalAction: ''
    };
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page + 1;
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return [];
      }
      var from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      var to = from + (this.offset * 2);
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      var pagesArray = [];
      while (from <= to) {
        pagesArray.push(from);
        from++;
      }
      return pagesArray;
    },
    role() {
      return localStorage.getItem("role");
    }
  },
  components: {
    Loading,
    DatePicker
  },
  mounted() {
    this.getEPurseTransfersData();
  },
  methods: {
    ...mapActions(["getEPurseTransfers", "approveEPurseTransfer"]),

    viewTransferDetails(transfer) {
      this.selectedTransfer = transfer;
      this.$bvModal.show("transfer-details");
    },

    openApprovalModal(transfer, action) {
      this.selectedTransfer = transfer;
      this.approvalAction = action;
      this.$bvModal.show("approval-modal");
    },

    processApproval() {
      let self = this;

      this.isLoading = true;

      const payload = {
        id: this.selectedTransfer.id,
        status: this.approvalAction
      };

      console.log('Approving/Rejecting transfer with payload:', payload);

      this.approveEPurseTransfer(payload)
        .then(function (response) {
          console.log('Approval response:', response);
          self.isLoading = false;

          self.$bvToast.toast(
            `Transfer ${self.approvalAction == 'APPROVED' ? 'approved' : 'rejected'} successfully`,
            {
              title: 'Success',
              variant: 'success',
              autoHideDelay: 5000,
              appendToast: false
            }
          );

          self.getEPurseTransfersData();
          self.$bvModal.hide("approval-modal");
        })
        .catch(function (error) {
          console.error('Approval error:', error);
          self.isLoading = false;

          let errorMessage = 'An error occurred';
          if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          self.$bvToast.toast(errorMessage, {
            title: 'Error',
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: false
          });
        });
    },

    changePage: function (page) {
      this.pagination.current_page = page;
      this.getEPurseTransfersData();
    },

    getEPurseTransfersData() {
      let self = this;

      this.isLoading = true;

      this.getEPurseTransfers({
        page: this.pagination.current_page,
        size: 10,
        startDate: this.start_date,
        endDate: this.end_date,
        status: this.status
      })
        .then(function (response) {
          self.isLoading = false;

          self.transfers = response.content;

          self.pagination.current_page = response.number;
          self.pagination.total = response.totalElements;
          self.pagination.per_page = response.numberOfElements;
          self.pagination.from = response.pageable.offset + 1;
          self.pagination.to = response.pageable.pageSize;
          self.pagination.last_page = response.totalPages;
        })
        .catch(function (error) {
          self.isLoading = false;

          if (typeof error.response !== "undefined") {
            if (error.response.status == 401) {
              location.replace("/login");
            }
          }
        });
    },

    clearFilter() {
      this.start_date = "all";
      this.end_date = "all";
      this.status = "all";
      this.getEPurseTransfersData();
    }
  }
};
</script>

<style scoped>
table tr th {
  padding-top: 10px;
  padding-bottom: 10px;
}

table td {
  padding: 10px;
}

label {
  font-size: 14px;
}
</style>
